export default {
  common: {
    menu: "メニュー",
    keywordSearch: "検索キーワードを入力",
    actions: "アクション",
    add: "増加",
    edit: "コンパイラ",
    view: "調べる",
    tag: "タグ",
    collapseMenu: "メニューを折りたたむ",
    save: "セーブ",
    cancel: "キャンセル",
    delete: "削除",
    deleteConfirmMsg: "削除してもよろしいですか？",
    no: "いいえ",
    yes: "はい",
    noDataAvailable: "データがありません",
    reason: "ラショナル",
    createdBy: "作成者",
    modifiedBy: "修正者",
    saveChanges: "変更を保存",
    close: "閉じる",
    pleaseEnter: "入力してください...",
    globalSmartSearch: "グローバル検索...",
    loadingText: "データを読み込んでいます。お待ちください。",
    collapse: "折りたたむ",
    expand: "展開",
    search: '検索',
    paracetamol: 'パラセタモール',
    disable: '無効',
    saveAndNext: 'セーブ＆ネクスト',
    inactive: '非アクティブ',
    user: 'ユーザー',
    downloadPDF: "PDFダウンロード",
    typeofAssociation: "協会タイプ",
    recordName: "レコード名",
    tip: {
      addSuccess: "追加成功。",
      addFailed: "追加に失敗しました。",
      updateSuccess: "更新に成功しました。",
      updateFailed: "更新に失敗しました。",
      revertSuccess: "リストア成功。",
      revertFailed: "リストアに失敗しました。",
      deleteSuccess: "削除に成功しました。",
      deleteFailed: "削除に失敗しました。",
      deletion: "削除理由を入力してください。",
      limit_2000: "2000文字を超える最大制限を入力しました。",
      selectOneItem: "アイテムを一つ選択してください。",
      selectTarget: "まず、ターゲットを選択してください。",
    },
  },
  validation: {
    isRequired: "必須"
  },
  appLauncher: {
    admin: {
      title: "ユーザー管理",
      subTitle: "ユーザーを管理できます",
    },
    tenant: {
      title: "テナント管理",
      subTitle: "あなたのテナントを管理できます",
    },
  },
  date: {
    receivedDate: "受信日",
    dueDate: "期限日",
    responseDate: "応答日",
    binderApprovalDate: "バインダー承認日",
    createdDate: "作成日",
    modifiedDate: "修正日",
  },
  menu: {
    dashboards: "ダッシュボード",
    products: "製品",
    rtqs: "RTQs",
    components: "コンポーネント",
    component_contents: "コンポーネント内容",
    settings: "設定",
    document_types: "ドキュメントタイプ",
    document_records: "ドキュメントレコード",
    published_documents: "公開ドキュメント",
    pinned: "ピン留め",
    recent: "最近の",
    searchModule: "検索モジュール",
    aiAssistant: "AIアシスタント",
    modules: 'モジュール'
  },
  domain: {
    label: "ドメイン",
    pluralLabel: "ドメイン",
    medicalProduct: "医薬品",
    medicalDevices: "医療機器",
    foodAndSupplements: "食品とサプリメント",
    consumer: "消費者",
  },
  tool: {
    summarizer: "要約者",
    translator: "翻訳者",
  },
  aiAssistant: {
    title: "こんにちは <b>Suren</b>！私はあなたのチャット<b>アシスタント</b>です！",
    subTitle: "rimに関する質問は何でもお聞かせください。詳細を理解するように努めます。",
    placeholder: 'ここにレジを入力してください。'
  },
  product: {
    products: "製品",
    addProduct: "製品を追加",
    editProduct: "製品を変更",
    productNameTooltip: "製品の名前",
    productTypeTooltip: "製品のタイプ",
    productFamilyCodeTooltip: "製品コード: OG-xxxx",
    activeIngredientSubstance: "活性成分/物質",
    strength: "濃度",
    strengthUnit: "濃度単位",
    dosageForm: "投与形態",
    basicInformation: "基本情報",
    routeOfAdmin: "管理経路",
    tradeName: "商標名",
    genericNameOrFamilyName: "一般名/ファミリー名",
    countryGroup: "国家グループ",
    country: "国家",
    pack: 'パッケージ',
    shelfLife: '賞味期限',
    storageCondition: '保存条件',
    category: "製品カテゴリ",
    type: "製品タイプ",
    subcategory: "製品サブカテゴリ",
    name: "製品名",
    birthdate: "国際生産日",
    businessunit: "ビジネスユニット",
    studyNumber: "研究番号",
    studyDescription: "研究説明",
    studyApprovalDate: "研究承認日",
    productsDes: "製品情報",
    showActive: 'アクティブを表示',
    showInactive: '非アクティブを表示',
    showDisabled: '無効を表示',
    reasonForDisable: '無効の理由',
    comment: 'コメント',
    disableProduct: "製品を無効化",
    disableProductTitle: 'この製品を無効化してもよろしいですか',
    disableProductHaveDependency: '<p style="text-align: left;">選択した製品は、以下のrtqに使用されているため、<b>無効化することはできません</b>。依存関係を削除してください。</p>',
    disableProductSuccessTip: 'このレコードを無効化しました',
    deleteSubstanceSuccessTip: '有効成分/物質を削除しました.',
    createSubstanceSuccessTip: '有効成分/物質を作成しました.',
    updateSubstanceSuccessTip: '有効成分/物質を更新しました.',
    updateTradeSuccessTip: '商標名を更新しました.',
    deleteTradeSuccessTip: '商標名を削除しました.',
    createTradeSuccessTip: '商標名を作成しました.',
    updateRouteSuccessTip: '管理経路を更新しました.',
    deleteRouteSuccessTip: '管理経路を削除しました.',
    createRouteSuccessTip: '管理経路を作成しました.',
    recordExistsTip: 'レコードが既に存在します。異なるレコードを再入力してください。',
    updateProductSuccessTip: '製品の更新に成功しました。',
    createProductSuccessTip: '製品の作成に成功しました。',
    reasonForInactive: '非アクティブの理由',
    productCategory: '製品カテゴリ',
    productSubcategory: '製品サブカテゴリ',
    productType: '製品タイプ',
    productFamilyCode: '製品ファミリコード',
    productName: '品名',
    pharmaceuticalDoseForm: '薬物剤形',
    therapeuticArea: '治療区域',
    productStatus: '製品ステータス',
    productStatusDate: '製品ステータス日付',
    description: '説明',
    comments: 'コメント',
    ingredients: '食材',
    addIngredients: 'を加えて炒め',
    addIngredientsQuantity: 'を加えて炒め量',
    ingredientsQuantity: '成分量',
    compositions: '構成',
    storageConditions: '保管条件',
    changeComposition: '構成を変更する',
    changeIngredient: '成分を変更する',
    createCompositionsSuccessTip: '構成が正常に作成されました。',
    updateCompositionsSuccessTip: '構成が正常に更新されました。',
    deleteCompositionsSuccessTip: '構成が正常に削除されました。',
    createStorageConditionsSuccessTip: '保管条件が正常に作成されました。',
    updateStorageConditionsSuccessTip: '保管条件が正常に更新されました。',
    deleteStorageConditionsSuccessTip: '保管条件が正常に削除されました。',
    deleteCompositionsWithDependency: "依存関係があるこの構成を削除してもよろしいですか？",
    deleteComposition: "選択された構成が削除されます。続行しますか？",
    editComposition: "この構成は他のレコードで使用されています。本当に進めてもよろしいですか？",
    editIngredient: 'この成分は他のレコードで使用されています。本当に進めてもよろしいですか？',
    deleteStorageCondition: "選択された保管条件が削除されます。続行しますか？",
    createIngredientsSuccessTip: '配料制作成功。',
    updateIngredientsSuccessTip: '配料更新成功。',
    deleteIngredientsSuccessTip: '成功删除配料。',
    deleteIngredientsWithDependency: "この成分には依存関係があるので、本当に削除したいのですか?",
    deleteIngredientsTip: "選択した成分は削除されます。続行しますか?",
    createIngredientsQuantitySuccessTip: '成功创建数量。',
    updateIngredientsQuantitySuccessTip: '配料数量更新成功。',
    deleteIngredientsQuantitySuccessTip: '配料数量删除成功。',
    deleteIngredientsQuantityTip: '選択した材料の数量が削除されます。続行しますか?',
    businessRule: '业务规则',
    compositionCategory: '成分类别',
    document: {
      chooseFile: 'ファイルを選択',
      switchRadioButton: 'ラジオボタン間の移動はデータの損失につながります',
      deleteDocumentSuccessTip: 'ドキュメントが正常に削除されました。',
      updateDocumentSuccessTip: 'ドキュメントが正常に更新されました。',
      addDocumentSuccessTip: 'ドキュメントが正常に追加されました。',
      editDocument: 'ドキュメントを編集',
      addDocument: 'ドキュメントを追加',
      documentURL: 'ドキュメントのURL',
      uploadFromLocal: 'ローカルからアップロード',
      documentNumber: 'ドキュメント番号',
      documentName: 'ドキュメント名',
      url: 'URL',
      confirmDeleteDocument: 'このドキュメントを削除してもよろしいですか？',
      allowedFileTypes: "<b>注意</b>：許可されるファイルタイプ \"<b>.doc, .docx, .pdf, .jpeg, .xlsx</b>\"、最大サイズ：<b>5MB</b>",
      waringAllowedFileTypes: '5MB以下のファイルをアップロードしてください。'
    },
    file: {
      uploadFileSuccessTip: 'ファイルが正常にアップロードされました。'
    },
  },
  rtq: {
    addRtq: "RTQを追加",
    title: "タイトル",
    category: "カテゴリ",
    healthAuthority: "保健当局",
    query: {
      label: "クエリ",
      pluralLabel: "クエリ",
      queryStatus: "クエリステータス",
      queryTopicTitle: "クエリトピック/タイトル",
    },
    tab: {
      basicInformation: "基本情報",
      basicInformationDes: "製品の基本情報を提供します",
      questionResponseDetails: "質問と回答の詳細",
      questionResponseDetailsDes: "質問と回答の詳細",
      products: "製品",
      productsDes: "製品情報",
      submissions: "提出",
      submissionsDes: "提出情報",
      categories: "カテゴリ",
      categoriesDes: "適用するカテゴリを選択します",
      documents: "ドキュメント",
      documentsDes: "クエリに関連するドキュメントをアップロードします",
      workflow: "ワークフロー",
      workflowDes: "ワークフローとクエリステータスを参照します",
    },
    submission: {
      label: "提出",
      pluralLabel: "提出",
      submissionType: "提出タイプ",
      procedureType: "手続きタイプ",
      applicationNumber: "申請番号",
      mANumber: "MA番号",
      controlNumber: "制御番号",
      comments: "コメント",
    },
    question: {
      addQuestion: "質問を追加",
      questionDescription: "質問の説明",
      questionStatus: "質問ステータス",
      assignedTo: "割り当て先",
      comments: "コメント",
    },
    response: {
      addResponse: "回答を追加",
      editResponse: "回答を編集",
      responseDescription: "回答の説明",
      department: "部門",
      responseStatus: "回答ステータス",
    },
    mentionsText: "ここで行動日付を言及し、RTQ所有者を割り当てます",
    owner: "所有者",
  },
  filter: {
    apply: "適用",
    and: "および",
    clear: "クリア",
    searchIntro: "コンテンツをフィルタリングするために選択または選択解除できます。",
    selected: "選択済み",
    more: "もっと",
    identifiers: "フィルタ項目",
    product: {
      label: "製品名",
      totalLabel: "すべての製品",
      searchPlaceholder: "製品を検索",
    },
    markets: {
      label: "市場",
      totalLabel: "すべての市場",
      searchPlaceholder: "市場を検索",
    },
    country: {
      label: "国",
      totalLabel: "すべての国",
      searchPlaceholder: "国を検索",
    },
    function: {
      label: "機能",
      totalLabel: "すべての機能",
      searchPlaceholder: "機能を検索",
    },
    rtq_date: {
      label: "日付",
      fromDatePlaceholder: "開始日を選択",
      toDatePlaceholder: "終了日を選択",
      lessThanPlaceholder: "最大日付を選択",
      moreThanPlaceholder: "最小日付を選択",
      lessThan: "より小さい日付",
      moreThan: "より大きい日付",
      between: "日付範囲",
    },
    active_substance: {
      label: "有効成分/物質",
      totalLabel: "すべての有効成分/物質",
      searchPlaceholder: "有効成分/物質を検索",
    },
    registration_no: {
      label: "登録番号",
      totalLabel: "すべての登録番号",
      searchPlaceholder: "登録番号を検索",
    },
    device_id: {
      label: "デバイスID",
      totalLabel: "すべてのデバイスID",
      searchPlaceholder: "デバイスIDを検索",
    },
    device_name: {
      label: "デバイス名",
      totalLabel: "すべてのデバイス名",
      searchPlaceholder: "デバイス名を検索",
    },
    device_type: {
      label: "デバイスタイプ",
      totalLabel: "すべてのデバイスタイプ",
      searchPlaceholder: "デバイスタイプを検索",
    },
    document_type: {
      label: "ドキュメントタイプ",
      totalLabel: "すべてのドキュメントタイプ",
      searchPlaceholder: "ドキュメントタイプを検索",
    },
    document_record: {
      label: "ドキュメントレコード",
      totalLabel: "すべてのドキュメントレコード",
      searchPlaceholder: "ドキュメントレコードを検索",
    },
    document: {
      label: "ドキュメント",
      totalLabel: "すべてのドキュメント",
      searchPlaceholder: "ドキュメントを検索",
    },
    filterItems: {
      label: "フィルタ項目",
      totalLabel: "すべてのフィルタ項目",
      searchPlaceholder: "フィルタ項目を検索",
    },
  },
  popup: {
    unSaveChanges: '変更を保存せずに閉じる',
    confirmUnSaveChanges: 'このページを離れてもよろしいですか？保存されていない変更は失われます。',
  },
  audit: {
    entityIdentifier: 'エンティティ識別子',
    auditIdentifier: '監査識別子',
    entityName: 'エンティティ名',
    entityCreatedDate: '作成日時',
    entityModifiedDate: '修正日時',
    fieldName: 'フィールド名',
    beforeModification: '修正前',
    afterModification: '修正後',
    operationType: '操作タイプ',
    operationDate: '操作日時',
    note: '注意: このテーブルには、このトランザクション中に更新されたフィールドのみが含まれています',
    audit: '監査'
  },
};